type NotStartedIconProps = {
  className?: string;
};

const NotStartedIcon = (props: NotStartedIconProps) => (
  <svg
    className={props.className !== undefined ? props.className : ""}
    width="12"
    height="1"
    viewBox="0 0 12 1"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.516602" width="11.4" height="0.6" rx="0.3" fill="#757575" />
  </svg>
);

export default NotStartedIcon;
